module.exports = __webpack_public_path__ + "3aafa126814f90c4e88f8f1bf4536d27.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/pages/layout/profile-menu/images/avatar_placeholder.png
 ** module id = 1308
 ** module chunks = 0
 **/